import { gql } from '@apollo/client'

import { PRIORITY_TASK_FRAGMENT } from '../fragments'

const PRIORITY_TASK_QUERY = gql`
  query priorityTaskQuery($id: ID!) {
    priorityTask(id: $id) {
      ...PriorityTaskFragment
    }
  }
  ${PRIORITY_TASK_FRAGMENT}
`

export default PRIORITY_TASK_QUERY
